import { createSelector } from 'reselect';
import { State } from 'types';

export function baseEntertainmentVideoSelector(state: State) {
  return state.entertainmentVideos;
}

export const isEditModeSelector = createSelector(
  baseEntertainmentVideoSelector,
  state => state.isEditMode
);

export const isUpdatingSelector = createSelector(
  baseEntertainmentVideoSelector,
  state => state.isUpdating
);

export const isDecliningSelector = createSelector(
  baseEntertainmentVideoSelector,
  state => state.isDeclining
);

export const isPublishingSelector = createSelector(
  baseEntertainmentVideoSelector,
  state => state.isPublishing
);

export const isUnpublishingSelector = createSelector(
  baseEntertainmentVideoSelector,
  state => state.isUnpublishing
);
